enum UserGroups {
  ADMIN = "Administrators",
  CONTRIBUTOR = "Contributors"
}

export default UserGroups
